
class MathUtil {
    convertBytesToMb(bytes) {
        return (bytes / 1024) / 1024;
    }

    convertMbToBytes(megabytes) {
        return (megabytes * 1024) * 1024;
    }
}

const mathUtil = new MathUtil();
export default mathUtil;